export default "__VITE_ASSET__CK0Ftrpu__"